import { VISIBILITY_FILTERS } from "../constants.js";
import _ from 'lodash'
export const getTodosState = store => store.entryReducer;

export const getTodoList = store =>
  getTodosState(store) ? _.keys(getTodosState(store).entries) : [];
  //getTodosState(store) ? getTodosState(store).allIds : [];

export const getTodoById = (store, id) =>
  getTodosState(store) ? { ...getTodosState(store).entries[id], id } : {};

/**
 * example of a slightly more complex selector
 * select from store combining information from multiple reducers
 */
export const getTodos = store =>
  getTodoList(store).map(id => getTodoById(store, id));

export const getTodosSorted=(store, sorter)=>{
  let allTodos = _.sortBy(getTodos(store), [sorter.column, 'date']);
  if(!sorter.asc)
    allTodos = _.reverse(allTodos);
    
  return allTodos;
}

export const getTodosByVisibilityFilter = (store, visibilityFilter) => {
  const allTodos = getTodos(store);
  switch (visibilityFilter) {
    case VISIBILITY_FILTERS.COMPLETED:
      return allTodos.filter(todo => todo.completed);
    case VISIBILITY_FILTERS.INCOMPLETE:
      return allTodos.filter(todo => !todo.completed);
    case VISIBILITY_FILTERS.ALL:
    default:
      return allTodos;
  }
};
